// src/pages/Insights.tsx
import { useState } from "react";
import { INSIGHT_POSTS, InsightPost } from "../data/posts";
import InsightsIndex from "../pages/Insights/InsightsIndex";
import InsightDetail from "../pages/Insights/InsightDetail";

const InsightsPage: React.FC = () => {
  const [selectedId, setSelectedId] = useState<string | null>(
    INSIGHT_POSTS[0]?.id ?? null
  );

  const selected: InsightPost | null =
    INSIGHT_POSTS.find((item) => item.id === selectedId) ?? null;

  return (
    <div className="bg-bg pb-16">
      {/* Hero / intro */}
      <section className="py-14 sm:py-16 border-b border-line">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <header className="mb-6">
            <p className="kicker mb-4">Insights</p>
            <h1 className="font-display text-2xl sm:text-3xl font-semibold text-ink mb-3">
              Thinking at the intersection of AI, governance, and real systems.
            </h1>
            <p className="text-sm sm:text-base text-muted max-w-2xl">
              Essays, patterns, and field notes from building trustworthy AI
              systems in finance, healthcare, utilities, and other high-stakes
              environments. Less hype, more things you can actually apply.
            </p>
          </header>

          <div className="flex flex-wrap gap-2">
            <span className="tag-chip">AI strategy &amp; transformation</span>
            <span className="tag-chip">Governance &amp; policy</span>
            <span className="tag-chip">Observability &amp; safety</span>
            <span className="tag-chip">RAG &amp; agentic systems</span>
          </div>
        </div>
      </section>

      {/* Main layout */}
      <section className="pt-10">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-[1.1fr,1.4fr] gap-6 lg:gap-8 items-start">
          <InsightsIndex
            insights={INSIGHT_POSTS}
            selectedId={selectedId}
            onSelect={setSelectedId}
          />
          <InsightDetail insight={selected} />
        </div>
      </section>
    </div>
  );
};

export default InsightsPage;
